/* eslint-disable @typescript-eslint/naming-convention */
export const avatarConfig = {
  Children: '/assets/img/default_avatar.png',
  Parent: '/assets/img/avatar_default_parent.png',
  Teacher: '/assets/img/avatar_default_parent.png'
};
